import styled from 'styled-components';

export const FormGroup = styled.div`
  padding: 0.375em 0;
  margin-bottom: 0.625em;
`;

export default FormGroup;
